import {signInUser, loginOut, getAdminInfo} from '@/api'
import {getToken, setToken, removeToken} from "@/utils/auth";
import {resetRouter} from '@/router'
import {Message} from "element-ui";

const getDefaultState = () => {
    return {
        token: getToken(),
        name: '',
        avatar: ''
    }
}

const state = getDefaultState()

const mutations = {
    RESET_STATE: (state) => {
        Object.assign(state, getDefaultState())
    },
    SET_TOKEN: (state, token) => {
        state.token = token
    },
    SET_NAME: (state, name) => {
        state.name = name
    },
    SET_AVATAR: (state, avatar) => {
        state.avatar = avatar
    }
}

const actions = {
    // user login
    login({commit}, userInfo) {
        const {username, password,slider_verify_code} = userInfo
        return new Promise((resolve, reject) => {
            signInUser({username: username.trim(), password: password,slider_verify_code:slider_verify_code}).then(response => {
                const {data} = response
                Message({type: data.level, message: data.message})
                if (data.level === 'success') {
                    commit('SET_TOKEN', data.data)
                    setToken(data.data)
                }
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },

    // get user info
    getInfo({commit, state}) {
        return new Promise((resolve, reject) => {
            getAdminInfo().then(response => {
                const {data,level} = response
                if (!data) {
                    return reject('Verification failed, please Login again.')
                }
                if (level==='success'){
                    const {admin_name} = data.admin_info
                    commit('SET_NAME', admin_name)
                }
                // commit('SET_AVATAR', avatar)

                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },

    // user logout
    logout({commit, state}) {
        return new Promise((resolve, reject) => {
            loginOut().then(() => {
                removeToken() // must remove  token  first
                resetRouter()
                commit('RESET_STATE')
                resolve()
            }).catch(error => {
                reject(error)
            })
        })
    },

    // remove token
    resetToken({commit}) {
        return new Promise(resolve => {
            removeToken() // must remove  token  first
            commit('RESET_STATE')
            resolve()
        })
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}

